module.exports = __webpack_public_path__ + "img/ptpr_sidenav_bg.404f9bdd.png";